import Vue from "vue";
import VueCookies from "vue-cookies";
import axios from "axios";

Vue.use(VueCookies);

const axiosInstance = axios.create({
	baseURL: process.env.VUE_APP_URL_API
});

axiosInstance.interceptors.request.use(
	function(config) {
		//const token = `Bearer ${VueCookies.get("token")}`;
		const token = localStorage.getItem("ckd");
		if (token) {
			config.headers.Authorization = token;
		}
		return config;
	},
	function(error) {
		return Promise.reject(error);
	}
);

function decodeBase64Json(encodedData) {
	const decodedString = decodeURIComponent(escape(atob(encodedData.od)));
	return JSON.parse(decodedString);
}

// Interceptor de resposta para decodificar Base64 corretamente
axiosInstance.interceptors.response.use(
	function(response) {
		if (response.data && response.data.od) {
			try {
				return Promise.resolve({ ...response, data: decodeBase64Json(response.data) });
			} catch (error) {
				console.error("Erro ao decodificar JSON:", error);
			}
		}
		return response;
	},
	function(error) {
		return Promise.reject(error);
	}
);

var config = {
	headers: { "Access-Control-Allow-Origin": "*" }
};

export const api = {
	get(endpoint) {
		if (process.env.VUE_APP_SITE == "7live" && process.env.VUE_APP_ADMIN == "false") {
			if (endpoint.startsWith("/evento/view/")) {
				endpoint = endpoint.replace("/evento/view/", "/Y2764ttUK1jd/bMPSxwY220j0/");
			} else if (endpoint.startsWith("/evento")) {
				endpoint = endpoint.replace("/evento", "/Y2764ttUK1jd");
			} else if (endpoint.startsWith("/usuario/meus-dados")) {
				endpoint = endpoint.replace("/usuario/meus-dados", "/fO70cM0hzE1h/ojebT00Gq1Fv");
			} else if (endpoint.startsWith("/sessao/session")) {
				endpoint = endpoint.replace("/sessao/session", "/9VpXJe4wJi0i/952wOjZLPxip");
			}
		}

		return axiosInstance.get(endpoint, config);
	},
	post(endpoint, body) {
		if (process.env.VUE_APP_SITE == "7live" && process.env.VUE_APP_ADMIN == "false") {
			if (endpoint.startsWith("/sessao")) {
				endpoint = endpoint.replace("/sessao", "/9VpXJe4wJi0i");
			} else if (endpoint.startsWith("/usuario/recuperar-senha")) {
				endpoint = endpoint.replace("/usuario/recuperar-senha", "/fO70cM0hzE1h/r5hh5WltR7Gs");
			}
		}

		return axiosInstance.post(endpoint, body, config);
	},
	put(endpoint, body) {
		if (process.env.VUE_APP_SITE == "7live" && process.env.VUE_APP_ADMIN == "false") {
			if (endpoint.startsWith("/sessaoView")) {
				endpoint = endpoint.replace("/sessaoView", "/v4037Jdd9XyP");
			}
		}

		return axiosInstance.put(endpoint, body, config);
	},
	delete(endpoint) {
		return axiosInstance.delete(endpoint, config);
	},
	valid(result, $router) {
		if (result.erro && result.erroTipo && result.erroTipo == "TOKEN") {
			localStorage.removeItem("ckd");
			$router.go({ name: "login" });
		}
	}
};
